const CLUSTER_ID_PATTERN = /^[1-9]\d{0,19}$/;

/**
 * The portal is open to every cluster. This only rejects values that are not a
 * well-formed cluster id — missing, blank, or non-numeric after decoding — so
 * malformed URLs and API payloads still land on `/invalid` instead of
 * rendering a page against a garbage tenant.
 */
export const isAllowedClusterId = (
  clusterId: string | null | undefined
): boolean => Boolean(clusterId && CLUSTER_ID_PATTERN.test(clusterId));
